import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Stack, Typography } from "@mui/material";
import { isFunction } from "lodash";
import { BreadcrumbItem } from "../interfaces";

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <Stack direction="row" gap={1} alignItems='center'>
      {items.map((item, i) => {
        const isLastItem = i === items.length - 1;
        const isFirstItem = i === 0;
        const textColor = isLastItem ? "primary.main" : "";
        const cursor = isFunction(item.onClick) ? "Pointer" : "";

        return (
          <>
            {item.title && !isFirstItem && (
              <ArrowForwardIosIcon fontSize="inherit" />
            )}
            <Typography
              onClick={item?.onClick as any}
              sx={{
                // fontSize: "1rem",
                // lineHeight: "1",
                color: textColor,
                cursor,
              }}
            >
              {item.title}
            </Typography>
          </>
        );
      })}
    </Stack>
  );
}
